/**
 * Une seule société ouverte à la fois, dans tous les onglets.
 *
 * <p>La société ouverte est celle de la session, partagée par tous les
 * onglets du navigateur. Un onglet passait au Magasin et rechargeait ; l'autre
 * affichait encore « Bâtiment » mais lisait et écrivait déjà dans le Magasin —
 * une facture créée là partait dans la mauvaise société. Chaque onglet annonce
 * la société qu'il montre ; celui qui en voit une autre annoncée se recharge.
 */

const CLE = 'swisstech.societeOuverte';

/**
 * Annonce aux autres onglets la société désormais ouverte.
 *
 * @param {number|string} id société ouverte
 */
export function annonceSociete(id) {
  try {
    localStorage.setItem(CLE, String(id));
  } catch {
    // Navigation privée ou stockage bloqué : rien à partager.
  }
}

/**
 * Recharge l'onglet dès qu'un autre onglet ouvre une autre société, ou quand
 * on revient sur cet onglet après un changement fait ailleurs.
 *
 * @param {number|string|null} id société montrée par cet onglet
 * @param {() => void} [recharge] rechargement, remplaçable en test
 * @returns {() => void} arrête la surveillance
 */
export function surveilleSociete(id, recharge = () => window.location.reload()) {
  if (id == null || typeof window === 'undefined') return () => {};
  const ici = String(id);
  annonceSociete(ici);
  const autre = (v) => !!v && v !== ici;
  const surStockage = (e) => {
    if (e.key === CLE && autre(e.newValue)) recharge();
  };
  const auRetour = () => {
    if (document.visibilityState !== 'visible') return;
    try {
      if (autre(localStorage.getItem(CLE))) recharge();
    } catch {
      // Stockage illisible : la session du serveur reste la référence.
    }
  };
  window.addEventListener('storage', surStockage);
  document.addEventListener('visibilitychange', auRetour);
  return () => {
    window.removeEventListener('storage', surStockage);
    document.removeEventListener('visibilitychange', auRetour);
  };
}
